/**
 * License API — instance-global ainetwork license (offline-verified).
 * See docs/superpowers/specs/2026-06-21-m5-licensing-paywall-design.md
 */
import type { components } from './schema.gen';
import apiClient from './client';

type Schemas = components['schemas'];
export type LicenseStatus = Schemas['LicenseStatusResponse'];

export const licenseAPI = {
  get: async (): Promise<LicenseStatus> => {
    const response = await apiClient.get<LicenseStatus>('/license');
    return response.data;
  },
  upload: async (token: string): Promise<LicenseStatus> => {
    const response = await apiClient.post<LicenseStatus>('/license', { token });
    return response.data;
  },
  remove: async (): Promise<void> => {
    await apiClient.delete('/license');
  },
};
